import { useDispatchAsyncGlobalAction } from 'hooks/useGlobalAction';

export const useBroadcastRefreshCurrentCase = (): (() => Promise<void>) => {
  return useDispatchAsyncGlobalAction('use-current-case');
};
